// src/scenes/contributionPolicy/monthlyContributionForm.jsx
import React, { useState } from "react";
import { Card, CardContent, Typography, Divider, Stack, TextField, Button, Box } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

/**
 * Simple extracted form:
 * - Monthly Amount
 * - Due Day
 * - Save Policy (creates a new policy record; activation happens via maker-checker actions in grid)
 */
const MonthlyContributionForm = ({ theme, onSave, saving }) => {
  const [monthlyAmount, setMonthlyAmount] = useState("");
  const [monthlyDueDate, setMonthlyDueDate] = useState("5");

  const handleSubmit = async () => {
    const res = await onSave?.({ amount: monthlyAmount, dueDate: monthlyDueDate });
    if (res?.ok) {
      setMonthlyAmount("");
      // keep due date as is (common)
    }
  };

  return (
    <Card sx={{ borderRadius: 3, mb: 2 }}>
      <CardContent>
        <Box display="flex" justifyContent="space-between" alignItems="center" gap={2} flexWrap="wrap">
          <Typography variant="h6" fontWeight={800}>
            1) Monthly Contribution Setup
          </Typography>

          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleSubmit}
            disabled={saving}
            sx={{ borderRadius: 2, fontWeight: 800 }}
          >
            {saving ? "Saving..." : "Save Policy"}
          </Button>
        </Box>

        <Typography variant="body2" sx={{ color: theme.palette.secondary[200], mt: 0.6 }}>
          Creating a policy saves it as a record. The approver will approve/activate it from the table below.
        </Typography>

        <Divider sx={{ my: 2, opacity: 0.35 }} />

        <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
          <TextField
            label="Monthly Amount (KES)"
            value={monthlyAmount}
            onChange={(e) => setMonthlyAmount(e.target.value)}
            type="number"
            fullWidth
          />
          <TextField
            label="Due Day (1 - 31)"
            value={monthlyDueDate}
            onChange={(e) => setMonthlyDueDate(e.target.value)}
            type="number"
            fullWidth
          />
        </Stack>
      </CardContent>
    </Card>
  );
};

export default MonthlyContributionForm;